import { InputNumber, Slider } from 'antd';
import { styled } from 'styled-components';
import { Text } from '@ydistri/ds';

export const InputNumber100Px = styled(InputNumber)`
  width: 100px;
`;

export const InputNumberFullWidth = styled(InputNumber)`
  width: 100%;
`;

export const SliderInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 15rem;
`;

export const SliderField = styled(Slider)`
  flex: 1;
  min-width: 10rem;
  margin: 0;
`;

export const LabelFieldWrapper = styled.label`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
`;

export const TextWithTooltip = styled(Text)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
